export default {
  deposit: '入金 BBG',
  withdraw: '提現 BBG',
  available: '遊戲內可用 BBG：{{amount}}',
  onChain: 'World App BBG：{{amount}}',
  wldFee: '提現手續費：0.05 WLD（World App）',
  amount: '數量',
  confirm: '確認',
  cancel: '取消',
  unfreeze: '解凍',
  max: '最大',
  inputHint: '這筆交易由 Bubble Wallet 完成。',
  worldAppOnly: '請在 World App 開啟 Bubble Wallet 完成這筆交易。',
  processing: '處理中…',
  depositTransactionTitle: '入金 BBG 中…',
  depositTransactionDescription: '正在透過 World App 將 {{amount}} BBG 發送到 Bubble Game 金庫。',
  payingWldTitle: '支付 WLD 中…',
  payingWldDescription: '正在向 World App 發送 0.05 WLD 作為 BBG 提現手續費。',
  preparing: '準備交易中…',
  success: '交易已完成。',
  successTitle: 'BBG 入金成功',
  successDescription: 'BBG 已記入你的遊戲內錢包。',
  withdrawalSuccessTitle: 'BBG 出金成功',
  withdrawalSuccessDescription: 'BBG 已發送到你的 World App 錢包。',
  successAmount: '入金數量',
  successChainId: 'Chain ID',
  successTxHash: 'Transaction Hash',
  successCreditedAt: 'Credited at',
  viewOnWorldscan: '在 Worldscan 查看 Transaction Hash',
  withdrawalViewOnWorldscan: '在 Worldscan 查看 Transaction Hash',
  done: '完成',
  failed: '交易失敗。',
  pending: '提款正在處理中。',
  finalizePending: 'BBG 已上鏈，帳本同步中，請勿重複支付手續費。',
  pendingNoDuplicate: '請勿重複支付手續費；可返回總覽查看狀態。',
  pendingStatusUnavailable: '暫時無法確認鏈上提款狀態，請重新登入後再試。',
  noBalance: '沒有可用餘額。',
} as const;
